module.exports = __webpack_public_path__ + "img/idea.0996d101.png";